import { UPLOAD_CONS } from '@core/constants/UploadConstants';
import { UploadLargeFile } from './UploadLargeFile';
import { UploadSmallFile } from './UploadSmallFile';

export class UploadFileImplementation {

  protected universalService: any;
  static singleInstance: any;
  uploadLargeFile: any;
  uploadSmallFile: any;


  constructor(protected globalService) {
    this.initializeProperties()
  }

  initializeProperties() {
    this.universalService = this.globalService.getUniversalServiceRef();
    // this.universalService.MarkNewObjArray = [];
    this.uploadLargeFile = UploadLargeFile.getInstance(this.globalService);
    this.uploadSmallFile = UploadSmallFile.getInstance(this.globalService)

  }

  public static getInstance(globalService): UploadFileImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new UploadFileImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public async uploadFile(fileobj, currentUploadFolder, queueIndex, isfolderFileUpload,ffile,resolveFromQueue,uploadQueue) {
    const classRef = this;
    let response
    if (fileobj.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
      response = await classRef.uploadLargeFile.startLargeFileReadAndUpload(fileobj, queueIndex, isfolderFileUpload,ffile,resolveFromQueue,[],uploadQueue);
    } else {
      response = await classRef.uploadSmallFile.startSmallFileUpload(fileobj, queueIndex, isfolderFileUpload,ffile,resolveFromQueue,uploadQueue);
    
    }
    fileobj.waiting = false;
    
    if (!isfolderFileUpload && response["status"] == "error") {
      let err = response["response"]["error"]["error"];
      classRef.universalService.showToast(err, "error");
    }else{
      
    }
    if(!isfolderFileUpload){
      resolveFromQueue()
    }
    return response;
  }






}